let accordionTriggers = document.querySelectorAll('[data-accordion-group] .accordion-button[aria-controls]');

for (let i = 0; i < accordionTriggers.length; i++) {
  initAccordionTrigger(accordionTriggers[i]);
}

function initAccordionTrigger(trigger) {
  trigger.addEventListener('click', (e) => {
    let triggerClickedCodename = trigger.getAttribute('aria-controls');
    window.history.replaceState({}, '', '#' + triggerClickedCodename);
  });
}

let accordionGroup = initHash('data-accordion-group');

function scrollToHash(elem) {
  if (!elem) return;
  let groupPosition = elem.getBoundingClientRect().top;
  let headerHeight = document.querySelector('.page-wrapper header').offsetHeight;
  let offsetPosition = groupPosition + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

function initHash(rootDataAttribute) {
  if (!window.location.hash) return;
  let hashTarget = window.location.hash.replace('#', '');
  let elem = document.querySelector('[' + rootDataAttribute + '=\'' + hashTarget + '\']');
  if (!elem) return;

  if (rootDataAttribute === 'data-accordion-group') {
    let group = elem;

    while (group) {
      let trigger = group.querySelector(':scope .accordion-button[aria-controls]');
      let isExpanded = trigger && trigger.getAttribute('aria-expanded') === 'true';
      if (trigger && !isExpanded) {
        trigger.click();
        elem = trigger;
      }
      group = group.parentNode.closest('[data-accordion-group]');
    }
  } else if (rootDataAttribute === 'data-modal-trigger') {
    elem.click();
  }

  setTimeout(() => {
    scrollToHash(elem);
  }, 300);

  // eslint-disable-next-line consistent-return
  return elem;
};


window.addEventListener('DOMContentLoaded', () => {
  scrollToHash(accordionGroup);
});
